import { create } from 'apisauce';

const LOCAL_API_URL = 'http://192.168.0.99:5000';

// const LIVE_API_URL = 'https://preprod.publiconsult.fr/api';

const LIVE_API_URL = 'https://www.publiconsult.fr/api';

export const CURRENT_API = process.env.NODE_ENV === 'development' ? LOCAL_API_URL : LIVE_API_URL

export const api = create({
  baseURL: CURRENT_API,
});
